import { RbiOrderStatus } from 'generated/rbi-graphql';
import { useUserOrders } from 'hooks/use-user-orders';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

/**
 * Checks total number of refunds that a user has and determines
 * whether or not the user is allowed to initiate a refund.
 */
export const useCheckUserRefundsCount = () => {
  const { loading, orders } = useUserOrders({
    orderStatuses: [RbiOrderStatus.REFUND_SUCCESSFUL, RbiOrderStatus.REFUND_REQUESTED],
  });

  const maxFullRefundCount = useFlag(LaunchDarklyFlag.MAX_CUSTOMER_INITIATED_FULL_REFUND_COUNT);
  const maxPartialRefundCount = useFlag(
    LaunchDarklyFlag.MAX_CUSTOMER_INITIATED_PARTIAL_REFUND_COUNT
  );

  const countFullRefunds = orders.reduce(
    (count, order) => (order?.order?.refund ? count + 1 : count),
    0
  );

  const countPartialRefunds = orders.length - countFullRefunds;

  const areTotalRefundsWithinLimit =
    countFullRefunds < maxFullRefundCount && countPartialRefunds < maxPartialRefundCount;

  const orderRefunded = countFullRefunds || countPartialRefunds;

  return {
    loading,
    areTotalRefundsWithinLimit,
    orderRefunded,
  };
};
